<!--
 * @description: 
 * @Author: Loadman
 * @Date: 2020-11-11 18:28:07
 * @LastEditors: Loadman
 * @LastEditTime: 2020-11-11 19:57:35
-->
<template>
    <div class="detial">
        <div class="banner"></div>
        <div class="contentCom">
            <div class="title">
                {{title}}
            </div>
            <div class="content" v-html="content">
            </div>
            <div style="text-align:right">
                <el-button type="info" @click="$router.go(-1)" round>返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            title:'',
            content:'',
        }
    },
    methods: {
        async getData(id){
            const {data: res} = await this.$autPost({id},this.$getDetailUrl)
            this.title = res.rows[0].noticeTitle
            this.content = res.rows[0].noticeContent
        }
    },
    mounted () {
        if (this.$route.query) {
            if (this.$route.query.id) {
                this.getData(this.$route.query.id)
            }
        }
    },
}
</script>

<style scoped>
    .banner {
        width: 1400px;
        margin: 0 auto;
        background: url(../assets/images/banner.jpg);
        height: 306px;
    }
    @media screen and (max-width: 1366px){
        .banner {
            width: 100%;
        }
    }
    .contentCom {
        margin: 20px auto 50px;
        width: 1200px;
    }
    .title {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        padding: 10px 0;
    }
</style>